import forceRealPageReload from './util/compatibility/force_real_page_reload';

const onWindowPageshow = function(event) {

    forceRealPageReload(event);

};

export default onWindowPageshow;
